import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import commonStore from '../../stores/CommonStore';

const DynamicField = ({ 
    children = [],
    fieldName = '' }) => {
  const { dynamicFieldsConfig } = commonStore;

  const showContent = dynamicFieldsConfig && dynamicFieldsConfig.find((item) => item === fieldName);

  return showContent ? children : null;
};


DynamicField.propTypes = {
  children: PropTypes.node,
  fieldName: PropTypes.string,
};

export default observer(DynamicField);